import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';

import {
  generateWatchlistPreviewElementFromElement,
  generateWatchlistPreviewElementFromWatchlist
} from '../model/watchlist-preview-element/watchlist-preview-element.generators';
import { WatchlistPreviewElement } from '../model/watchlist-preview-element/watchlist-preview-element';
import { WatchlistElementObjectType } from '../model/watchlist-element/watchlist-element-object-type.enum';
import { WatchlistWithChildLists } from '../model/watchlist/watchlist-with-child-lists';


/**
 * Represents a watchlist preview
 */
@Component({
  selector: 'p1-watchlist-preview',
  templateUrl: 'watchlist-preview.component.html',
  styleUrls: ['watchlist-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WatchlistPreviewComponent implements OnInit, OnChanges {

  @Input()
  watchlist: WatchlistWithChildLists;

  @Input()
  maxPreviewCount: number;

  ElementType = WatchlistElementObjectType;

  previewElements: WatchlistPreviewElement[] = [];


  /**
   * Creates the watchlist preview component
   */
  constructor() {}

  ngOnInit(): void {
    this.previewElements = this._preparePreviewElements();
  }

  ngOnChanges(): void {
    this.previewElements = this._preparePreviewElements();
  }

  _preparePreviewElements(): WatchlistPreviewElement[] {
    let previewElements: WatchlistPreviewElement[] = [];

    if (this.watchlist.elements) {
      previewElements = previewElements.concat(this.watchlist.elements.map(element => generateWatchlistPreviewElementFromElement(element)));
    }

    if (this.watchlist.childLists) {
      previewElements = previewElements.concat(this.watchlist.childLists.map(generateWatchlistPreviewElementFromWatchlist));
    }

    return previewElements.sort((elementA, elementB) => {
      if (elementA == null) {
        return -1;
      }
      if (elementB == null) {
        return 1;
      }
      return elementB.added > elementA.added ? 1 : -1;
    });
  }
}
